module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	"use strict";

	var _ = {
		getTranslation: function(alias) {
			var translation = {
				'communityNickname': function() {return fox.i18n.getTranslation('communityNickname', 'Community Nickname', 'dialog');},
				'cancel': function() {return fox.i18n.getTranslation('cancel', 'Cancel', 'dialog');},
				'save': function() {return fox.i18n.getTranslation('save', 'Save', 'dialog');}
			};

			return translation[alias] || '';
		}
	};

	fox.registerWidget('Layout_Base', {
		//Widget config

		configure: function(options) {
			this.registerOptions('', {
				pageContainer: '#page-container',
				messageMenu: '.menu-item span.messages',
				messageDashBoard: '.spt_bl1_4 .newMessages',
				commentsDashBoard: '.spt_bl1_4 .newComments',
				commentsMenu: '.menu-item span.comments',
				shadow: '.guiShadowOverlay',
				popup: '.guiCasualPopup',
				memberDetails: '.current.member',
				handleDom: {
					memberLogout: {
						target: '#logout',
						event: 'click',
						callback: 'logout'
					},
					community: {
						target: '#community',
						event: 'click',
						callback: 'community'
					},
					addNewPost: {
						event: 'click',
						target: '.add-new-post',
						callback: 'addNewPost'
					}
				},
				widgets: {

					apiCommentCount: {
						widget: 'Api',
						method: 'comments.getNewCount',
						useSocket: true
					},
					apiMessageCount: {
						widget: 'Api',
						method: 'conversation.getNewMsgCount',
						useSocket: true
					},

					createCommunityName: {
						widget: 'PopupWidget',
						title: _.getTranslation('communityNickname'),
						additionalClass: 'new-member-container',
						dialog: {
							width: '470px',
							buttons: [
								{text: _.getTranslation('cancel'), class: 'additBtn guiButton guiSmall guiColorMinor guiMinorBlue close', id: 'cancel-communityName'},
								{text: _.getTranslation('save'), class: 'additBtn guiButton guiSmall guiColorCasual', id: 'save-communityName'}
							]
						},
						widgets: {
							communityNamePopup: {
								widget: 'Popup_CommunityName',
								autoRender: true
							}
						}
					},
					informationPopup: {
						widget: 'PopupWidget',
						dialog: {
							dialogClass: 'dlg-amc dark-overlay congratulation-popup',
							title: 'Welcome to Modelcentro'
						},
						widgets: {
							congratulation: {
								widget: 'Registration_Congratulations',
								autoRender: true,
								template: 'registration_congratulation'
							}
						}
					},
					copyright: {
						widget: 'Copyright',
						template: 'layout_base_copyright'
					},
					footerTermsofserviceLinks: {
						widget: 'Widget',
						'embed.container': '.footer .footer-menu',
						template: 'footer_termsofservice_links',
						autoRender: true
					}
				},
				handleWom: {
					apiCommentSuccess: {
						widget: '#apiCommentCount',
						event: 'success',
						callback: '@this:apiCommentSuccess'
					},
					apiMessageSuccess: {
						widget: '#apiMessageCount',
						event: 'success',
						callback: '@this:apiMessageSuccess'
					},
					'navigator': {
						'event': 'modified_0',
						widget: fox.Navigator,
						callback: '@this:navigatorHandler',
					}
				},

				'hooks.onAddedToDom': fox.bind(function () {
				//	this.showInformationPopup();
					this.newCommentsCheck();
					this.checkNewMessages();
				}, this)
			});

			this.callParent('configure', arguments);
		},

		navigatorHandler: function() {
			this.rwom1('#apiCommentCount').send();
		},

		checkNewMessages: function (argument) {
			this.rwom1('#apiMessageCount').send();
		},

		apiMessageSuccess: function(res) {			
			var data = {
					resp: {
						totalCount: res.answer.response.success.totalCount
					}
				};

			this.newChatMessageReceived(data);
		},

		init: function() {
			var logo = fox.getEnv('siteLogo');

			this.notBlockedClient = false;
			this._commentCount = 0;
			
			if (fox.cookie.empty('noUpdateMessage')) {
				this.embedWidget('currentCommentReload', 'Comment_PeriodicalUpdater', {});
			}

			// new fox.LocalStorageObjectService({lsLabel: '_ufn_'}); is not assigned 

			if (fox.getEnv('public.agencyId') > 0 && logo) {
				this.setTemplateOptions({siteLogo: logo});
			}

			return this.callParent('init', arguments);
		},

		running: function() {
			this.newMessagePopup = this.wom1('~#newMessagePopup');
			this.handleEvent(fox.site, 'changeOnRead', fox.bind(this.changeOnReadComment, this));
			this.handleEvent(fox.site, 'newChatMessageReceived', fox.bind(this.newChatMessageReceived, this));
			this.handleEvent(fox.site, 'changeCommentsMenu', fox.bind(this.changeCommentsMenu, this));
			this.handleEvent(fox.site, 'loadedConversationList', fox.bind(this.initConversationList, this));
		},

		community: function() {
			// window.open('http://vanilla/');
			if (fox.cookie.get('nickName')) {
				window.open('https://community.modelcentro.com/');
			} else {
				var clientNick = fox.wom.selectFirst('@root').getOption('clientNick');
				this.rwom1('~#createCommunityName ~#form').setValue('communityName', clientNick.communityName);
				this.rwom1('~#createCommunityName').show();
			}
		},

		addNewPost: function () {
			var api =  this.getApi('postAdd', {method: 'blog.post.add'});

			api.send();

			this.handleEvent(api, 'success', function (res) {
				fox.site.gotoPage('post', {1: res.answer.response});
			});
		},

		initConversationList: function(object) {
			this.newMessagePopup.setList(object);
		},

		changeOnReadComment: function(data) {
			var delta = this._commentCount - data.newComment;
			this.changeCommentsMenu(delta);
		},

		newChatMessageReceived: function(answer) {
			var	
				count = parseInt(answer.resp.totalCount);

			$(this.options.messageMenu).text(count > 0 ? ['+', count].join('') : '');

			this.setDashboardMessageCounter(count);
		},

		setDashboardMessageCounter: function(count) {
			if(count > 0) {
				$(this.options.messageDashBoard).prev('div').find('a').removeClass('empty').attr('href' , '/messages');
			}
			
			$(this.options.messageDashBoard).text(count > 0 ? ['+', count].join('') : '');
		},
	
		newCommentsCheck: function(response) {		
			this.rwom1('#apiCommentCount').send();
		},

		apiCommentSuccess: function(data) {
			var response = data.answer.response.success;
			this.changeCommentsMenu(response.newCount);
		},

		changeCommentsMenu: function(count) {
			count = parseInt(count);

			if (count > 0) {
				this._commentCount = count;
				$(this.options.commentsMenu).text(['+', count].join(''));
			} else {
				this._commentCount = 0;
				$(this.options.commentsMenu).text('');
			}

			this.setDashboardCommentCount(count);
		},

		setDashboardCommentCount: function(count) {
			count = (typeof count === 'object') ? 0 : count;

			if(count > 0) {
				$(this.options.commentsDashBoard).prev('div').find('a').removeClass('empty').attr('href' , '/comments');
			}

			$(this.options.commentsDashBoard).text(count);
		},

		menuState: function() {
			if (!fox.isEmpty(fox.site.member)) {
				$('.dlmenu').addClass('member');
			} else {
				$('.dlmenu').removeClass('member');
				//poka ne budet normalnogo if else v zencode
				var joinLink = joinLink || ''; //joinLink not defined
				$('.last .menu_link').attr('href', joinLink);
			}

		},

		logout: function() {
			fox.site.logout();
		},

		showMessagePopup: function(member, attachments) {
			var callee = this.rwom1('@root #home');
			
			return callee.showMessagePopup.apply(callee, arguments);
		},

		//temporary inserted for hiding editor link in top menu for some clients
		showEditorLink: function () {},

		showInformationPopup: function () {
			if (fox.cookie.get('showInformationPopup')) {
				setTimeout(fox.bind(function () {
					this.rwom1('#informationPopup').show();
				}, this), 1000);
				
				fox.cookie.remove('showInformationPopup');
			}
		}

	}, 'BaseMain');

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ../common/widget/layout/base.js
// module id = 464
// module chunks = 2